import { EventTypes } from '@plugins/emitter-bus.js';

export default {
  alteraVisualizacao({ commit }, { emitterGlobal }) {
    commit('TOGGLE_MENU');
    emitterGlobal.emit(EventTypes.ToggleMenuSuperior, null);
  },
  resetMenuState({ commit }) {
    commit('SET_MENU_STATE', false);
  },
};
